import './csv-upload.less';
import React from 'react';

const Upload = props => {
	return (
		<div className="upload-csv-file">
			<label className="file-upload-label">
				Upload file
				<input
					type="file"
					className="control"
					onChange={e => props.preparationCsv(e.target.files[0], props.onChange)}/>
			</label>
		</div>
	);
};

export default Upload;




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/form-elements/csv-upload.js